module.exports = __webpack_public_path__ + "img/logo.70932a22.svg";